module.exports = __webpack_public_path__ + "static/media/UA.4af0450b.png";